// extracted by mini-css-extract-plugin
export default {"spinnerWrapper":"virtual_spinnerWrapper__gNHw9","infoText":"virtual_infoText__L-JFe","successText":"virtual_successText__THlde","summary":"virtual_summary__Bx78o"};